import * as React from 'react';
import * as styles from './styles.css';

import { Header2, InlineText1 } from '@cian/ui-kit/typography';

export interface IExpertViewProps {
  title: string;
  text: string;
  url: string;
  onClick?(): void;
}

export function ExpertView({ title, text, url, onClick }: IExpertViewProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        <h2 className={styles['title']}>
          <Header2>{title}</Header2>
        </h2>
        <div className={styles['text']}>
          <InlineText1>{text}</InlineText1>
        </div>
        <a href={url} onClick={onClick} className={styles['link']}>
          <InlineText1 color="primary_100">Читать статью</InlineText1>
        </a>
      </div>
    </div>
  );
}
